import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import CTADoubleLink from '../../../components/CTADoubleLink';

import WysiwygField from '../../../components/WysiwygField';

import './style.scss';

const ParagraphCtaDouble = ({ id, entity }) => {
  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.value;
  const CTAparagraphs = paragraph.field_cta_paragraphs;

  return (
    <Container id={id} className="Paragraph ParagraphCtaDouble">
      <div className="row">
        <div className="ParagraphCtaDouble__body col-12 col-md-12 col-lg-8">
          {title && (
            <h2>{title}</h2>
          )}
          {body && (
            <WysiwygField
              property="schema:text"
              html={body}
            />
          )}
        </div>
      </div>
      <div className="row ParagraphCtaDouble__content">
        {CTAparagraphs.map((CTAparagraph) => {
          return (
            <div className="ParagraphCtaDouble__inner col-md-6">
              <CTADoubleLink
                CTAparagraph={CTAparagraph}
              />
            </div>
          );
        })}
      </div>
    </Container>
  );
};


export default ParagraphCtaDouble;
